import { Pressable, Text, View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { useTranslation } from 'react-i18next'
import { ArrowLeft } from 'lucide-react-native'
import { colors } from '@chillout/core'

interface CashierBackHeaderProps {
  title: string
}

export function CashierBackHeader({ title }: CashierBackHeaderProps) {
  const { t } = useTranslation()
  const navigation = useNavigation()

  return (
    <View className="relative flex-row items-center justify-center px-4 py-3">
      <Pressable
        onPress={() => navigation.goBack()}
        accessibilityLabel={t('cashierHeader.backButton')}
        accessibilityRole="button"
        hitSlop={8}
        className="absolute left-4"
      >
        <ArrowLeft size={24} color={colors.text.primary} strokeWidth={2} />
      </Pressable>
      <Text className="text-lg lg:text-xl font-semibold text-primary">{title}</Text>
    </View>
  )
}